import { SP } from '../../lib/shareTokens'

interface Props {
  onOpen: () => void
  deeplink?: string
  /** Replaces the default subline (ON-464: "Apply in the app" on selection / lottery events). */
  subtitle?: string
}

export default function SmartBanner({ onOpen, deeplink, subtitle }: Props) {
  return (
    <div style={{
      position: 'sticky',
      top: 0,
      zIndex: 40,
      background: 'rgba(10,10,10,0.85)',
      backdropFilter: 'blur(18px)',
      WebkitBackdropFilter: 'blur(18px)',
      borderBottom: `1px solid ${SP.border}`,
      padding: '10px 20px',
      display: 'flex',
      alignItems: 'center',
      gap: 12,
    }}>
      <img
        src="/app-icon.png"
        alt="Stazon"
        width={36}
        height={36}
        style={{ borderRadius: 9, flexShrink: 0 }}
      />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: SP.text, fontFamily: SP.ui, letterSpacing: -0.2 }}>
          Open in Stazon
        </div>
        <div data-testid="smart-banner-subtitle" style={{ fontSize: 11, color: SP.muted, fontFamily: SP.mono, letterSpacing: 0.5, marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {subtitle ?? 'Free · Running community app'}
        </div>
      </div>
      <button
        onClick={onOpen}
        data-testid="smart-banner-open"
        data-deeplink={deeplink}
        style={{
          padding: '8px 16px',
          borderRadius: 999,
          background: SP.lime,
          color: SP.charcoal,
          fontSize: 12,
          fontWeight: 700,
          cursor: 'pointer',
          flexShrink: 0,
          fontFamily: SP.ui,
          border: 'none',
        }}
      >
        Open
      </button>
    </div>
  )
}
